<template>
  <div>
    <header class="header-main">
      <div class="containers">
        <a style="cursor:pointer" class="logo-header"><img :src="getTranslations.project_logo_img" alt=""></a>
        <nav class="main-nav">
          <ul class="main-nav__lang free_game">
            <li class="dropdown">
              <a><i class="icon-planet"></i><i class="icon-arrow-down"></i></a>
              <ul>
                <li v-for="(value, key) in availableLocales" :key="key">
                  <a @click.prevent="changeLanguage(key)" style="cursor:pointer">{{ value }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    <main class="get-started">
      <div class="row">
        <h1 class="free_h1">
          <strong>{{ getTranslations.visitor_index_get_started_msg_1 }}</strong><br>
          <strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong><br>
          {{ getTranslations.visitor_index_get_started_msg_3 }}
        </h1>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="tablet"></div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="prize-img">
              <img src="static/images/Get-Started_prizes.png" alt="Duel prizes">
            </div>
          </div>
          <div class="row">
            <div class="button">
              <a style="cursor:pointer" @click.prevent="playTrial()" class="btn btn--large btn--main">{{ getTranslations.visitor_free_trial_play }}</a>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- MOBILE VIEW STARTS HERE -->
    <main class="get-started-mobile">
      <div class="row">
        <div class="col-md-12 tablet"><img src="static/images/safari_uc.png" alt=""></div>
        <div class="col-md-12 button">
          <a style="cursor:pointer" @click.prevent="playTrial()" class="btn btn--large btn--main">{{ getTranslations.visitor_free_trial_play }}</a>
        </div>
        <div class="col-md-12 title">
          <h1>
            <strong>{{ getTranslations.visitor_index_get_started_msg_1 }}</strong><br>
            <strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong><br>
            {{ getTranslations.visitor_index_get_started_msg_3 }}
          </h1>
        </div>
        <div class="col-md-12 prize-img">
          <img src="static/images/Get-Started_prizes.png" alt="Duel prizes"></div>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { handleLanguageDropdown } from '../../../common/jQuery';

export default {
  name: 'getStartedFreePlay',
  mounted() {
    this.$nextTick(() => {
      handleLanguageDropdown();
    });
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from , next) {
    next((vm) => {
      vm.getParameterInfo(to);
    });
  },
  methods: {
    ...mapMutations('i18n', [
      'updateLocaleFromLocalStorage',
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    getParameterInfo(to) {
      console.log(to.query.lang);
     // console.log(to.query.refUrl);
    },
    playTrial() {
      console.log('playing...');
      this.$router.replace('trial/searchingOpponent');
    },
    changeLanguage(newValue) {
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile();
      this.changeCSSFile();
    },
  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/GetStartedFreePlay.vue